<ng-container *ngIf="phase == 'loading'">
    <app-spinner></app-spinner>
</ng-container>
<ng-container *ngIf="phase == 'success'">
    <h1>Welcome {{user?.display_name}}!</h1>

    <p>You're all signed up and signed in!
        Welcome to the TYT community!</p>
</ng-container>
<ng-container *ngIf="phase == 'form'">
    <div class="prompt">
        <ng-container *ngIf="knownFirstName">
            {{knownFirstName}}, Join The TYT Community For Free.
        </ng-container>
        <ng-container *ngIf="!knownFirstName">
            Join The TYT Community For Free.
        </ng-container>
    </div>

    <form (submit)="submit()">
        <input *ngIf="!knownFirstName" name="firstName" autocomplete="given-name" [(ngModel)]="firstName" type="text" placeholder="First Name" />
        <input name="email" autocomplete="email" [(ngModel)]="email" type="text" placeholder="Email address" />
        
        <div class="alert alert-danger" *ngIf="emailErrorMessage">
            {{emailErrorMessage}}
            <br/>
            
            <ng-container *ngIf="extendedEmailNote">
                <div>
                <strong>Is your email address entered correctly?</strong><br/>
                In order to ensure you can access your account after signup we have implemented
                additional checks for common mistakes. Check the message above for more information
                about why you are seeing this message.<br/>
                <br/>
                Double check the email address you have entered to be sure that you've entered it correctly.
    
                If you are sure it's entered correctly, you may have a legitimate email address
                which these checks don't account for.<br/><br/>
    
                If you are sure your email address is entered correctly, contact support@tytnetwork.com and we'll
                help you get your account set up.
                </div>
                <br/>
                <br/>
            </ng-container>
            
            <a href="javascript:;" (click)="extendedEmailNote = true" *ngIf="!extendedEmailNote">More Info</a>
            <a href="javascript:;" (click)="extendedEmailNote = false" *ngIf="extendedEmailNote">Hide</a>
  
        </div>

        <input name="password" autocomplete="new-password" [(ngModel)]="password1" type="password" placeholder="Enter a Password" />
        <input name="password" autocomplete="new-password" [(ngModel)]="password2" type="password" placeholder="Confirm Password" />
        <input name="zip" [(ngModel)]="zip" type="text" placeholder="US Zip Code (Optional)" />

        <div class="newsletter" *ngIf="!knownEmailOptin">
            <label>
                <input name="newsletter" type="checkbox" [(ngModel)]="newsletter" /> 
                Receive news and alerts and daily recaps from TYT. You may manage
                communication preferences and opt-out at any time.
            </label>
        </div>

        <div class="flavor">
            Making a TYT account is fast and free!
        </div>

        <div class="alert alert-danger" *ngIf="errorMessage">
            {{errorMessage}}
        </div>

        <button>
            Sign up free
        </button>

        <div class="flavor">
            Or sign up with one click:
        </div>

        <div class="social-signups">
            <a [href]="oauthUrlFor('youtube')" class="youtube" aria-label="Sign in with YouTube" title="Sign up with YouTube (and bring your YouTube Channel Membership to TYT.com!)">
                <i class="fab fa-youtube"></i>
                <img src="/assets/google_signin_buttons/yt_logo_mono_dark.png" />
            </a>
            <a [href]="oauthUrlFor('facebook')" class="facebook" aria-label="Sign in with Facebook">
                <i class="fab fa-facebook-f"></i>
                <span class="text">Facebook</span>
            </a>

            <a [href]="oauthUrlFor('twitter')" class="twitter"  aria-label="Sign in with Twitter">
                <i class="fab fa-twitter"></i>
                <span class="text">Twitter</span>
            </a>
        </div>

        <div style="text-align: center; margin-top: 1.5em;">
            <a [href]="oauthUrlFor('google')" class="google"  aria-label="Sign in with Google">
                <img style="height: 46px" src="/assets/google_signin_buttons/web/2x/btn_google_signin_dark_normal_web@2x.png" alt="Sign in with Google" />
            </a>
        </div>

        <div class="more flavor">
            Already have an account?
        </div>
    </form>

    <a href="javascript:;" (click)="showLogin()" class="sign-in">Sign In</a>

    <div class="terms">
        By signing up via any of the above methods, you agree to TYT's
        <a [href]="termsUrl" target="_blank">Terms of Use</a>,
        <a [href]="privacyPolicyUrl" target="_blank">Privacy Policy</a>,
        and <a [href]="coreValuesUrl" target="_blank">Core Values</a>.
        
    </div>
</ng-container>